import { ShortCode } from '@highereducation/wordpress';
import { CardFooter } from '@highereducation/hen-ui';

type CardFooterShortcodeProps = {
  children?: React.ReactNode;
};

export const CardFooterShortcode: ShortCode<CardFooterShortcodeProps> = {
  component: ({ children }) => {
    return <CardFooter>{children}</CardFooter>;
  },
};
